export const receiveMaturityRulesets = (state, { payload = {} }) => {
  return state.set('maturityRulesets', payload.maturityRulesets);
};
